{{label}}
<div *ngIf="showSortBtn" class="btn-sort" [ngClass]="{'active': isHighlighted()}" (click)="onSortBtnClicked()">
    <bd-fa  [name]="faName"></bd-fa>
</div>
